module.exports = __webpack_public_path__ + "static/media/case1.9788167e.jpg";